import {AutogenLayoutMarketExprtGeneralPanel} from "./autogen/AutogenLayoutMarketExprtGeneralPanel";

export class MarketExprtGeneralPanel extends AutogenLayoutMarketExprtGeneralPanel{

}
